import { Injectable, inject } from '@angular/core';

import type { Observable } from 'rxjs';

import { AsyncJobService } from '@core/async-job-data';
import { HttpApiService } from '@core/http-legacy';

@Injectable({ providedIn: 'root' })
export class LocationsBulkActionsHttpClient {
  protected readonly httpApi = inject(HttpApiService);
  protected readonly asyncJob = inject(AsyncJobService);

  public merge({
    id,
    locationIds,
  }: {
    id: number;
    locationIds: number[];
  }): Observable<{ uuid: string }> {
    return this.httpApi.patch(`/locations/${id}/merge`, null, { locationIds });
  }
}
